@import 'common/component';

o2-radio-group {
  display: block;
}
